export async function streamAI(path, body, onDelta) {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok || !res.body) throw new Error("AI request failed");
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let full = "";
  let buf = "";
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.trim();
      if (line.startsWith("data:")) {
        try {
          const j = JSON.parse(line.slice(5).trim());
          if (j.text) {
            full += j.text;
            onDelta(j.text);
          }
        } catch (e) { /* ignore malformed chunk */ }
      }
    }
  }
  return full;
}
